import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Tooltip from '@omilia/tooltip';
import TrashTooltip from 'components/TrashTooltip';

import { constraintSetType } from 'types';
import InspectButton from 'components/InspectButton';

import './style.scss';

/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
class Header extends Component {
  static propTypes = {
    addEntity: PropTypes.func,
    addRefIntent: PropTypes.func,
    isExpanded: PropTypes.bool,
    item: constraintSetType,
    toggleExpand: PropTypes.func,
    onDelete: PropTypes.func,
    onDuplicate: PropTypes.func,
  };

  handleDuplicate = e => {
    const { onDuplicate } = this.props;
    e.stopPropagation();
    e.preventDefault();
    onDuplicate();
  };

  handleAddEntity = e => {
    const { addEntity } = this.props;
    e.stopPropagation();
    e.preventDefault();
    addEntity();
  };

  handleAddRefIntent = e => {
    const { addRefIntent } = this.props;
    e.stopPropagation();
    e.preventDefault();
    addRefIntent();
  };

  render() {
    const { item, isExpanded, toggleExpand, onDelete } = this.props;
    return (
      <div styleName="constraintset-header" onClick={toggleExpand}>
        <div styleName="name">
          <span
            className={cn({
              'icon-triangle-arrow-up': isExpanded,
              'icon-triangle-arrow-down': !isExpanded,
            })}
            data-test={
              isExpanded
                ? 'close-expanded-constraint-set-button'
                : 'expand-constraint-set-button'
            }
          />
          <span data-test="constraint-sets-name">{item.name}</span>
        </div>
        <div styleName="actions">
          {isExpanded &&
            (item.intent_reference === null ||
              item.intent_reference === undefined) && (
              <InspectButton
                isHeader
                data-action="add-refintent"
                data-test="add-intent-reference-button"
                onClick={this.handleAddRefIntent}
              >
                + Intent Reference
              </InspectButton>
            )}
          {isExpanded && (
            <InspectButton
              isHeader
              data-action="add-entity"
              data-test="add-entity-button"
              onClick={this.handleAddEntity}
            >
              + Add Entity
            </InspectButton>
          )}
          <div styleName="buttons">
            <div styleName="seperator" />
            <Tooltip content="Duplicate constraint set">
              <button
                className="icon-duplicate rule"
                data-test="duplicate-constraint-set-button"
                type="button"
                onClick={this.handleDuplicate}
              />
            </Tooltip>
            <div styleName="seperator" />
            <TrashTooltip
              data-test="delete-constraint-set-button"
              text="Delete constraint set"
              onDelete={onDelete}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Header;
